import { Sound, Music } from 'types';

const BASE_SOUND: Sound = {
  name: '',
  type: null,
  url: null,
  buffer: null,
};

const MUSIC_SOUND: Music = {
  ...BASE_SOUND,
  lazy: true,
  loop: false,
  mood: -1,
  duration: 0,
  fadeIn: 0,
  fadeOut: 0,
  volume: 100,
  silenceAfter: 0,
  prevents: [],
};

export {
  BASE_SOUND,
  MUSIC_SOUND,
};
